import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { UpdateCrecaTradesAdditionsRequestModel, UpdateCrecaTradesAdditionsResponseModel } from "@/features/accounts/creca/services/update-trades-additions-model";

export class UpdateCrecaTradesAdditionsApi {
  /**
   * クレカAPI明細メモ・無効明細更新API
   */
  public updateCrecaTradesAdditions = async (
    param: UpdateCrecaTradesAdditionsRequestModel
  ): Promise<UpdateCrecaTradesAdditionsResponseModel> => {
    const path = `/api/crecaaccounts/crecas/tradesadditions`;
    const res = await ApiClient.instance.put<UpdateCrecaTradesAdditionsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
